/**
 * Fetches Appropriate Track Style BackgroundColor for Slider Based on Disabled Param
 * @function getTrackStyle
 * @param {Boolean} disabled
 * @return {Array.<Object>}
 */
export default disabled => disabled ? [{ backgroundColor: '#AFC1E1' }] : [{ backgroundColor: '#07337C' }];
